export enum OfficialReportType {
    Generic = 'MileageLoss',
    LateTakeover = 'LateTakeover',
    LateDeparture = 'LateDeparture',
    Headway = 'Headway',
}

export enum OfficialReportStatus {
    Draft = 'Draft',
    Submitted = 'Submitted',
    Sent = 'Sent',
}

export interface IOfficialReport {
    id: string
    incidentDate: string
    status: OfficialReportStatus
    subcategory: OfficialReportType
    authorBadgeNumber: string
    driverBadgeNumber: string
    issueLocation: string
    description: string
    driverStatement: string
    baseDepot: string
    takeOverTimeMode: LateTimeType
    takeOverDate: string
    actualTakeOverDate: string
    headways: ReportHeadway[]
    logId: string
    logRecordId: string
    userShift: {
        authorName: string
        badgeNumber: string
        busHubCode: string
        createdAt: string
        dutyCode: string
        id: string
        oid: string
    }
}

export interface ReportHeadway {
    id: string
    busStop: string
    observedAt: string
    headway: string | number
}

export enum LateTimeType {
    Scheduled = 'Scheduled',
    Given = 'Given',
}

export interface OfficialReportRequestBody {
    id: string
    incidentDate: string
    status: OfficialReportStatus
    subcategory: OfficialReportType
    driverBadgeNumber: string
    issueLocation: string
    description: string
    driverStatement?: string
    logId: string
    takeOverTimeMode?: string
    takeOverDate?: string
    actualTakeOverDate?: string
    headways?: Omit<ReportHeadway, 'id'>[]
}
